const VIMData = ({ data, onViewHistoricalData }) => {
  const connectivity = data?.connectivity || {}
  const metadata = data?.metadata || {}

  return (
    <div className="w-[360px] min-w-[360px] h-full bg-[#f9fafa] flex flex-col border-r border-[#dfe4ed] box-border">
    <div className="flex-1 flex flex-col gap-3 p-4 overflow-y-auto">
      <span className="text-sm font-medium text-[#252a34]">VIM Data</span>

      <div className="grid grid-cols-2 gap-2">
        <ParamCard icon="bolt" label="Voltage" value={data?.voltage || '-'} />
        <ParamCard icon="thermostat" label="Temperature" value={data?.temperature || '-'} />
      </div>

      <Divider />

      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-1.5">
          <span className="material-icons text-[18px] text-[#565f70]">signal_cellular_alt</span>
          <span className="text-sm font-medium text-[#272d37]">Connectivity</span>
        </div>
        <div className="flex flex-col">
          <Row label="MQTT status" value={connectivity.mqttStatus || '-'} valueColor={connectivity.mqttStatus === 'Connected' ? '#03791F' : connectivity.mqttStatus === 'Disconnected' ? '#d51d10' : undefined} />
          <Row label="Network strength" value={connectivity.networkStrength || '-'} />
          <Row label="Network type" value={connectivity.networkType || '-'} />
          <Row label="RAM used" value={connectivity.ramUsed || '-'} />
          <Row label="Uptime" value={connectivity.uptime || '-'} />
        </div>
      </div>

      <Divider />

      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-1.5">
          <span className="material-icons text-[18px] text-[#565f70]">layers</span>
          <span className="text-sm font-medium text-[#272d37]">Metadata</span>
        </div>
        <div className="flex flex-col">
          <Row label="SIM no." value={metadata.simNo || '-'} />
          <Row label="Organization" value={metadata.organization || '-'} />
        </div>
      </div>
    </div>

    <div className="flex flex-col items-center justify-center pb-4 pt-2 px-4">
      <button
        className="w-full h-9 flex items-center justify-center gap-2 rounded border border-[#dfe4ed] bg-[#f2f4f7] px-3 text-sm font-medium text-[#272d37] cursor-pointer"
        onClick={onViewHistoricalData}
      >
        View historical data
        <span className="material-icons text-xl">chevron_right</span>
      </button>
    </div>
    </div>
  )
}

const ParamCard = ({ icon, label, value }) => (
  <div className="bg-[#f2f4f7] rounded-lg px-3 py-2 flex flex-col gap-1.5">
    <div className="flex items-center gap-1">
      <span className="material-icons text-base text-[#616a79]">{icon}</span>
      <span className="text-sm font-normal text-[#616a79]">{label}</span>
    </div>
    <span className="text-sm font-medium text-[#272d37]">{value}</span>
  </div>
)

const Row = ({ label, value, valueColor }) => (
  <div className="flex justify-between items-center py-1.5 border-b border-[#f2f4f7]">
    <span className="text-sm font-normal text-[#616a79]">{label}</span>
    <span className="text-sm font-normal text-[#272d37]" style={valueColor ? { color: valueColor } : undefined}>{value}</span>
  </div>
)

const Divider = () => <div className="h-px bg-[#dfe4ed] shrink-0" />

export default VIMData
